import React from 'react';
import { Route } from 'react-router-dom';
import Routes from '../../constants/routes';
import cookies from '../../utils/browser-storage/cookies';
import session from '../../utils/session';

const PrivateRoute = ({ component: Component, ...rest }) => {
    if (!session.isLoggedIn()) {
        cookies.setItem('redirect_link', window.location.href, 1);
        window.locationReload(Routes.LOGIN.path);

        return null;
    }

    return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PrivateRoute;
